import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/architect/dispatch')({

}).lazy(() => import('./dispatch.lazy').then((d) => d.Route));
